import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { IonToolbar, IonTitle, IonIcon, IonGrid, IonRow, IonCol, IonButton, IonSpinner } from '@ionic/angular/standalone';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';


@Component({
    selector: 'app-session-expiry-modal',
    templateUrl: './session-expiry-modal.component.html',
    styleUrls: ['./session-expiry-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonIcon, IonGrid, IonRow, IonCol, IonButton, IonSpinner, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class SessionExpiryModalComponent implements OnInit, OnDestroy {

  @Input() secondsRemaining = 60;

  displayTime = '';
  loading = false;

  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.updateDisplay();
    this.intervalId = setInterval(() => {
      this.secondsRemaining--;
      this.updateDisplay();
      if (this.secondsRemaining <= 0) {
        this.clearInterval();
        this.modalController.dismiss(null, 'timeout');
      }
    }, 1000);
  }

  ngOnDestroy() {
    this.clearInterval();
  }

  extend() {
    this.loading = true;
    this.modalController.dismiss(null, 'extend');
  }

  private updateDisplay() {
    const mins = Math.floor(Math.max(this.secondsRemaining, 0) / 60);
    const secs = Math.max(this.secondsRemaining, 0) % 60;
    this.displayTime = `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  private clearInterval() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
